import babelpolyfill from 'babel-polyfill'
import '../theme/index.css'
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
//import 'element-ui/lib/theme-chalk/index.css'
import './assets/element-variables.scss'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './store'
import Vuex from 'vuex'

import routes from './routes'

import 'font-awesome/css/font-awesome.min.css'
import './assets/icon-font/iconfont.css'

import axios from 'axios' //引入axios
import SlideVerify from './lib/index'

Vue.config.productionTip = false
Vue.use(SlideVerify)

Vue.prototype.$ajax=axios //修改Vue的原型属性


import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)
console.log('process.env==', process.env.NODE_ENV)
let env = process.env.NODE_ENV
//NProgress.configure({ showSpinner: false });
let base = (function() {
    let path = location.pathname;
    if(/^\/authorize/.test(path)) {
      return '/authorize/';
    }
    if(env ==='test' &&  /^\/dnnCloud\/user/.test(path)) {
      console.log("dnnCloud/user/")
      return '/dnnCloud/user';
    }
    return '/';
  })();

if(sessionStorage.getItem('token')){
   store.commit('set_token',sessionStorage.getItem('token'))
}

const router = new VueRouter({
  mode:'history',  
  base: base,
  routes
})

router.beforeEach((to, from, next) => {
    console.log('to==', to, store.state.token)
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    };

    const dnnypt_checkCode = getCookie('dnnypt_checkCode');
    const dnnypt_token = getCookie('dnnypt_token');
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        if (dnnypt_checkCode && dnnypt_token) {  // 通过vuex state获取当前的token是否存在
            next();
        }else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
    }
})



//router.afterEach(transition => {
 //NProgress.done();
//});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js